import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as brandIcons from '@fortawesome/free-brands-svg-icons';
import * as solidIcons from '@fortawesome/free-solid-svg-icons';
import { useBusinessData } from '../../context/BusinessContext';
import '../../css/social-media.css';

const SocialMediaLinks = ({ variant = 'default', allowedPlatforms = null }) => {
  const { getData } = useBusinessData();

  // Get social media links, filtering out disabled ones and by allowed list
  const getSocialMediaLinks = () => {
    const socialMedia = getData('contactInfo.socialMedia', {});
    return Object.entries(socialMedia)
      // Filter out disabled platforms (enabled must be true or not set)
      .filter(([key, socialData]) => socialData.enabled !== false)
      // If allowedPlatforms is specified, only include those
      .filter(([key]) => allowedPlatforms === null || allowedPlatforms.includes(key))
      .map(([key, socialData]) => ({
        key,
        url: socialData.url || '#',
        icon: brandIcons[socialData.icon] || solidIcons.faLink,
        label: socialData.label || key.charAt(0).toUpperCase() + key.slice(1)
      }));
  };

  const socialLinks = getSocialMediaLinks();

  const containerClassName = `social-links-container ${variant}-social-links`;

  return (
    <div className="social-media-links">
      {variant === 'contact' && (
        <div className="info-item social-media-card">
          <FontAwesomeIcon icon={solidIcons.faShareAlt} className="info-icon" />
          <div className="social-media-content">
            <h3>{getData('ui.contact.socialMediaLabel', 'Connect With Us')}</h3>
            <div className={containerClassName}>
              {socialLinks.map(social => (
                <a 
                  key={social.key}
                  href={social.url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className={`social-link ${social.key}-link`}
                  title={social.label}
                >
                  <FontAwesomeIcon icon={social.icon} />
                  <span>{social.label}</span>
                </a>
              ))}
            </div>
          </div>
        </div>
      )}

      {variant !== 'contact' && (
        <>
          {variant === 'footer' && (
            <h4>{getData('ui.footer.socialMediaLabel', 'Follow Us')}</h4>
          )}
          <div className={containerClassName}>
            {socialLinks.map(social => (
              <a 
                key={social.key}
                href={social.url} 
                target="_blank" 
                rel="noopener noreferrer"
                className={`social-link ${social.key}-link`}
                title={social.label}
              >
                <FontAwesomeIcon icon={social.icon} />
                <span>{social.label}</span>
              </a>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default SocialMediaLinks; 